import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import Link from '@/components/Link';
import { useTranslation } from 'react-i18next';
import { translationKeys } from '@gik/i18n/en/app';
import routes from '@gik/core/routes';
import { useUserStore } from '@gik/core/store/UserStore';
import PageRowsSection from '../PageRows/PageRowsSection';
import { auth } from '@gik/auth';

export interface IUserNavProps extends React.HTMLAttributes<HTMLDivElement> {}

export default function UserNav({ className }: React.PropsWithChildren<IUserNavProps>): React.ReactElement {
  const bem = bemBlock('user-nav');
  const { t } = useTranslation();

  const userStore = useUserStore();
  const userId = userStore.id;

  return (
    <ul className={bem(null, null, className)}>
      <li>
        <PageRowsSection />
      </li>

      {!userId && (
        <li>
          <a className={bem('btn-signin')} onClick={() => auth.login()}>
            {t(translationKeys.signin)}
          </a>
        </li>
      )}
      {userId && (
        <>
          <li>
            <Link href={routes.userProfile}>
              <a>{t(translationKeys.viewEditProfile)}</a>
            </Link>
          </li>
          <li>
            <a onClick={() => auth.logout()}>
              <span className="tw-text-danger-500">{t(translationKeys.logout)}</span>
            </a>
          </li>
        </>
      )}
    </ul>
  );
}
